import { hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { resolveGeoRoute, geoRouteHead, redirectLegacyLocation } from "@/lib/geoRouteSeo";
import NotFound from "@/pages/NotFound";
import LocationOrStateRoute from "@/pages/LocationOrStateRoute";
import { getLocationTarget } from "@/data/locationTargets";
import { getApprovedTownContent } from "@/lib/townContent.functions";
import { stateSlugs } from "@/data/towns";

export const Route = createFileRoute("/_public/locations/$slug")({
  loader: async ({ params }) => {
    redirectLegacyLocation(params.slug);
    if (!resolveGeoRoute([params.slug])) throw notFound();
    // State hubs have no per-place copy; county/region pages do.
    if (stateSlugs.has(params.slug)) return { content: null };
    const target = getLocationTarget("", params.slug);
    if (!target) return { content: null };
    try {
      const content = await getApprovedTownContent({
        data: { stateSlug: target.stateSlug, townSlug: target.slug, serviceSlug: null },
      });
      return { content };
    } catch {
      return { content: null };
    }
  },
  component: LocationSlugPage,
  head: ({ params, loaderData, matches }) => geoRouteHead([params.slug], Boolean(loaderData) && !hasUnavailableMatch(matches)),
  notFoundComponent: NotFound,
  errorComponent: NotFound,
});

function LocationSlugPage() {
  const { content } = Route.useLoaderData();
  return <LocationOrStateRoute content={content} />;
}
